export const TIMELINE_ITEM_PREFIX = 'item_id_';
export const CLUSTER_ITEM = 'vis-cluster';
export const BREAK_ITEM = 'gantt-break';
export const TIMELINE_GROUP_ITEM = 'data-group';
export const LATE_ITEM = 'late';
export const GANTT_ITEM_ROW_CLASS = 'gantt-items-row';
